import { Button } from "@mui/material";
import { Line } from "components/client/rentalProperty/RentalProperty.style";
import ValidateTaxModal from "components/modals/ValidateTaxModal";
import PersonalCollection from "components/modals/review/ReviewConfirmation/PersonalCollection";
import GeneralBusinessModal from "components/modals/staffModals/GernalBusinessModal";
import CustomTable from "components/reusable/customTable/CustomTable";
import DateComponent from "components/reusable/datecomponent/DateComponent";
import StaffHeader from "components/reusable/header/StaffHeader";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiReq } from "services/Requests";
import styled from "styled-components";
import { API_ROUTES } from "utils/apiRoutes.constant";
import { getTaxYears } from "utils/getYear";
import * as XLSX from "xlsx";

const formattedDate = (value) => {
  const date = dayjs(value);
  const formattedDate = date.format("MM-DD-YYYY");
  return formattedDate;
};

const AdminTaxReturn = () => {
  const [refetch, setRefetch] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [submissionDate, setSubmissionDate] = useState("");
  const [tab_loader, setTabLoader] = useState(true);
  const [isValidateTaxModal, setIsValidateTaxModal] = useState(false);
  const [generalBusinessModal, setGeneralBusinessModal] = useState(false);
  const [personalCollectionModal, setPersonalCollectionModal] = useState(false);
  const [truckDriverModal, setTruckDriverModal] = useState(false);
  const [enableRowSelection, setEnableRowSelection] = useState(false); // State to manage row selection
  const [value, setValue] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [originaldata, setoriginalData] = useState();
  const [loading, setLoading] = useState(false);
  const handleSearchByName = (selectedValues) => {
    setSearchName(selectedValues.target.value);
    if (originaldata) {
      const filteredData = originaldata?.filter((item) =>
        item.sname
          .toLowerCase()
          .includes(selectedValues.target.value.toLowerCase())
      );
      setValue(filteredData);
    }
  };

  const fetchTaxFiling = async () => {
    try {
      if (startDate && !endDate) {
        toast.error("Please Select End date");
        return;
      } else if (!startDate && endDate) {
        toast.error("Please Select Start date");
        return;
      }

      const isStartDateAfterEndDate = startDate > endDate;
      if (isStartDateAfterEndDate) {
        toast.error("End date cannot be before the start date");
        return;
      }
      setLoading(true);
      setTabLoader(true);
      const response = await apiReq(
        API_ROUTES.queuesReportStaffActivity,
        "POST",
        {
          startDate,
          endDate,
          submissionDate,
        }
      );
      const responseData = await response.data;
      const updatedData = responseData?.data?.map((item, index) => {
        return {
          id: index + 1,
          sr: index + 1,
          sname: item?.assignTo?.firstName + " " + item?.assignTo?.lastName,
          cname: item?.clientId?.firstName + " " + item?.clientId?.lastName,
          bname: item?.formType,
          fprogress: item?.generalBusinessTaskId
            ? item?.generalBusinessTaskId?.formProgress
            : item?.personalCollectionTaskId
            ? item?.personalCollectionTaskId?.formProgress
            : item?.truckDriverTaskId
            ? item?.truckDriverTaskId?.formProgress
            : "N/A",
          llogin: "N/A",
          createdat: item?.createdAt,
          updateon: item?.updatedAt,
          taxYear: getTaxYears(item),
          status: item?.status,
          otherDetails: item,
        };
      });
      setValue(updatedData);
      setoriginalData(updatedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.message || "Error fetching data. please try again later."
      );
    } finally {
      setTabLoader(false);
    }
  };

  useEffect(() => {
    fetchTaxFiling();
  }, [refetch]);

  const individualColumns = [
    {
      field: "sr",
      headerName: "Sr#",
      width: 80,
      editable: false,
    },
    {
      field: "sname",
      headerName: "Staff Name",
      width: 200,
      editable: false,
    },
    {
      field: "cname",
      headerName: "Client Name",
      width: 200,
      editable: false,
    },
    {
      field: "bname",
      headerName: "Form Submission",
      width: 200,
      editable: false,
    },
    {
      field: "taxYear",
      headerName: "Tax Year",
      width: 180,
      editable: false,
    },

    {
      field: "fprogress",
      headerName: "Form Progress",
      width: 190,
      editable: false,
      renderCell: (params) => (
        <div>{params.value ? params.value : "-----"}</div>
      ),
    },
    {
      field: "llogin",
      headerName: "Last Login",
      width: 100,
      editable: false,
    },
    {
      field: "createdat",
      headerName: "Created Date",
      width: 150,
      editable: false,
      renderCell: (params) => <div>{formattedDate(params.value)}</div>,
    },
    {
      field: "updateon",
      headerName: "Modified Date",
      width: 150,
      editable: false,
      renderCell: (params) => <div>{formattedDate(params.value)}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: false,
    },
    // {
    //   // field: "comments",
    //   headerName: "Action",
    //   width: 100,
    //   editable: false,
    //   renderCell: (params) => (
    //     <div>
    //       <Button
    //         variant='text'
    //         color='primary'
    //         onClick={() => setGeneralBusinessModal(true)}
    //       >
    //         <img src={detail} alt='detail' />
    //       </Button>
    //     </div>
    //   ),
    // },
  ];

  const options = [
    { label: "Select ALL", value: "Select All" },
    { label: "Data Validation", value: "Data Validation" },
    { label: "Data Entry", value: "Data Entry" },
    { label: "Staff Review", value: "Staff Review" },
  ];
  const handleSelectChange = (selectedValues) => {
    // Handle select change logic
    console.log("select value");
  };

  const generateExcel = () => {
    const hasWorkSheet = value.some((item) =>
      item?.otherDetails?.formType?.includes("1099 WorkSheet")
    );
    const worksheet = XLSX.utils.json_to_sheet(value);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    if (hasWorkSheet) {
      // Find the number of columns
      const colCount = Object.keys(value[0] || {}).length;
      // Find the next row index (1-based)
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const nextRow = range.e.r + 2; // +1 for next row, +1 because rows are 0-indexed
      const cellAddress = `A${nextRow}`;
      worksheet[cellAddress] = {
        t: "s",
        v: "1099 Worksheets for contractors",
        s: {
          fill: { fgColor: { rgb: "FFF9C4" } }, // light yellow
          font: { color: { rgb: "000000" }, bold: true },
          alignment: { horizontal: "center" },
        },
      };
      // Merge the cell across all columns
      worksheet["!merges"] = worksheet["!merges"] || [];
      worksheet["!merges"].push({
        s: { r: nextRow - 1, c: 0 },
        e: { r: nextRow - 1, c: colCount - 1 },
      });
      // Update the worksheet range
      range.e.r = nextRow - 1;
      worksheet["!ref"] = XLSX.utils.encode_range(range);
    }
    XLSX.writeFile(workbook, "table.xlsx");
  };
  const ExlhandleButtonClick = () => {
    // Button click logic
    generateExcel();
  };

  const reFetchTaxFiling = () => {
    setRefetch(!refetch);
  };

  useEffect(() => {
    const searchStaff = async (searchValue) => {
      try {
        console.log(searchValue);
        const filteredAssignData = originaldata.filter((item) => {
          return item?.cname
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase());
          // item?.status?.toLowerCase().includes(searchValue?.toLowerCase()) ||
          // item?.priority?.toLowerCase().includes(searchValue?.toLowerCase())
        });

        setValue(filteredAssignData);
      } catch (error) {}
    };
    if (searchName) {
      searchStaff(searchName);
    }
  }, [searchName, originaldata]);

  return (
    <>
      <RentalPropertyContainer>
        <StaffHeader
          showFirstSelect={false}
          showSecondSelect={false}
          showButton={false}
          showSecondButton={false}
          showThirdButton
          clickHandler2={ExlhandleButtonClick}
          placeholder="Search by Name"
          options={options}
          btntext1="PDF"
          btntext2="Excel"
          onSelectChange={handleSelectChange}
          onChange={handleSearchByName}
          // searchStaff={searchStaff}
        />
        <Line border="0.0999999999999999px solid rgba(239, 243, 253, 1)" />
        <Button />
        <DateComponent
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          handleButtonClick={reFetchTaxFiling}
          loading={loading}
          submissionDate={submissionDate}
          setSubmissionDate={setSubmissionDate}
          endDate={endDate}
          startDate={startDate}
        />
        <RentalPropertyWrapper>
          <CustomTable
            rows={value}
            loading={tab_loader}
            enableRowSelection={enableRowSelection}
            columns={individualColumns}
          />
        </RentalPropertyWrapper>
      </RentalPropertyContainer>
      <ValidateTaxModal
        isModalOpen={isValidateTaxModal}
        closeModal={() => setIsValidateTaxModal(!isValidateTaxModal)}
        paragraph="Are you sure you want to submit for review?"
        setGeneralBusinessModal={setGeneralBusinessModal}
        generalBusinessModal={generalBusinessModal}
      />
      <GeneralBusinessModal
        generalBusinessModal={generalBusinessModal}
        setGeneralBusinessModal={setGeneralBusinessModal}
        personalCollectionModal={personalCollectionModal}
        setPersonalCollectionModal={setPersonalCollectionModal}
      />
      <PersonalCollection
        personalCollectionModal={personalCollectionModal}
        setPersonalCollectionModal={setPersonalCollectionModal}
        truckDriverModal={truckDriverModal}
        setTruckDriverModal={setTruckDriverModal}
      />
    </>
  );
};

export default AdminTaxReturn;

const RentalPropertyContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  background: #fff;
  width: 100%;
  padding: 20px;
  //min-height: 85vh;
`;

const RentalPropertyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 50px;
`;
